import { createFileRoute } from '@tanstack/react-router'
import { RequireAuth } from '@dss/auth'
import { RetiredScreen } from '../components/RetiredScreen'

/** /orders/pending — pending-заказы matcher (DO-8 / D18-8
 *  §«Pending-orders auto-matcher»). Permission-gating внутри экрана
 *  (без `distributor.orders.view-pending` показывается warning Banner). */
export const Route = createFileRoute('/orders/pending')({
  component: PendingOrdersRoute,
})

function PendingOrdersRoute() {
  return (
    <RequireAuth>
      <RetiredScreen />
    </RequireAuth>
  )
}
